<template>
  <section class="block-offer offer">
    <div class="container">
      <div class="offer__header">
        <h2 class="offer__title title">Абонементы</h2>
        <div class="swiper-pagination"></div>
        <div class="offer__controls" v-if="device_platform !== 'mobile'">
          <div class="arrow arrow-prev"></div>
          <div class="arrow arrow-next"></div>
        </div>
      </div>
      <div class="swiper-container offer-swiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(offer, index) in slides"
            :key="index"
          >
            <div
              class="offer__head"
              @click="
                getCall({
                  type: 'sale',
                  form: 'offer',
                  title: 'Узнать цену',
                })
              "
            >
              <h3 class="offer__name">{{ offer.name }}</h3>
              <p class="offer__time" v-if="offer.time">{{ offer.time }}</p>
            </div>
            <div class="offer__body">
              <p class="offer__age" v-if="offer.age">{{ offer.age }}</p>
              <ul class="offer__options-list">
                <li
                  class="offer__options-item"
                  v-for="(item, idx) in offer.options"
                  :key="idx"
                >
                  {{ item }}
                </li>
              </ul>
            </div>

            <button
              class="offer__btn button button_theme_primary"
              @click="
                getCall({
                  type: 'sale',
                  form: 'offer',
                  title: 'Узнать цену',
                })
              "
            >
              <span>Узнать больше</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Mixin from "../common/mixin";
import Swiper from "swiper";
import DATA from "../common/season-tickets-data";

export default {
  name: "block-offer",
  mixins: [Mixin],
  data() {
    return {
      swiper: null,
      slides: DATA,
    };
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    initSwiper() {
      if (this.swiper) return;
      this.swiper = new Swiper(`.offer-swiper`, {
        slidesPerView: "auto",
        spaceBetween: 24,
        loop: false,
        simulateTouch: true,
        navigation: {
          nextEl: `.offer .arrow-next`,
          prevEl: `.offer .arrow-prev`,
        },
        pagination: {
          el: ".offer .swiper-pagination",
          type: "progressbar",
        },
        breakpoints: {
          800: {
            spaceBetween: 12,
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.offer {
  padding: 38px 0 56px 0;
  background-color: #f7f9fb;

  &__header {
    position: relative;
    display: flex;
    align-items: flex-end;
    margin-bottom: 27px;
  }

  .swiper-slide {
    position: relative;
    max-width: 376px;
    height: 681px;
    display: flex;
    flex-direction: column;
  }

  .swiper-pagination {
    position: unset;
    flex: 1;
    height: 2px;
    margin: 0 14px 8px;
  }

  &__controls {
    margin-bottom: 5px;
  }

  &__head {
    text-align: center;
    background-color: $primary;
    color: $almost-gray;
    padding: 39.5px 0;
    cursor: pointer;
  }

  &__title {
    font-size: calcFontSize(24, 56, 320, 1440);
  }

  &__name {
    font-family: "Bebas Neue", sans-serif;
    font-size: 34px;
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 8px;
    letter-spacing: 0.05em;
  }

  &__body {
    flex: 1;
    padding: 8px 30px 8px 32px;
    background-color: $white;
  }

  &__time {
    font-size: 18px;
  }

  &__age {
    padding-left: 14px;
  }

  &__options-list {
    list-style: none;
  }

  &__options-item {
    margin-top: 18px;
    position: relative;
    padding-left: 14px;

    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: $almost-gray;
    }
  }

  &__btn {
    height: 46px;
    font-size: 18px;
    font-weight: normal;
  }
}

@media (max-width: 800px) {
  .offer {
    padding: 32px 0;
    .swiper-slide {
      max-width: 224px;
      height: 431px;
    }

    &__head {
      padding: 18px 0;
    }

    &__name {
      font-size: 22px;
      margin-bottom: 5px;
    }

    &__body {
      padding: 12px;
    }

    &__time {
      font-size: 14px;
    }

    &__age {
      padding-left: 8px;
    }

    &__options-item {
      font-size: 10px;
      margin-top: 8px;
      padding-left: 8px;
    }

    &__btn {
      font-size: 14px;
      height: 35px;
    }
  }
}

@media (max-width: 640px) {
  .offer {
    .swiper-slide {
      max-width: 236px;
      height: 540px;
    }

    &__options-item {
      font-size: 14px;
      margin-top: 10px;
    }
  }
}
</style>
